import React from 'react';

//components
import { InterventionCollapse } from '../../storyboard/common';

function AccordionFilter(props) {
    const { dataInterventions, value } = props && props;
    return (
        <React.Fragment>
            {dataInterventions?.map((item, index) => (
                <InterventionCollapse 
                    {...props}
                    item={item}
                    value={value}
                    interventionsIndex={index}
                />
            ))}
        </React.Fragment>
    );
};

export default AccordionFilter;